const faqData = [
    {
        id: 1,
        question: "How do wind turbines and solar panels work together in a renewable energy system?", 
        answer: "Wind turbines and solar panels generate electricity through different mechanisms. Wind turbines harness the kinetic energy of the wind to turn blades, which then drive a generator. Solar panels convert sunlight into electricity through the photovoltaic effect. When integrated into a renewable energy system, these technologies complement each other by providing a continuous and reliable power supply. Wind power is often more abundant during certain times, while solar power is consistent during daylight hours, resulting in a more stable overall energy output."
    },
    {
        id: 2,
        question: "What sets EcoSolution's renewable energy solutions apart from others on the market?",
        answer: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure magnam voluptas deleniti culpa, fuga dolores vitae praesentium quo inventore harum."
    },
    {
        id: 3,
        question: "How can businesses and communities benefit from integrating renewable energy solutions from EcoSolution?",
        answer: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure magnam voluptas deleniti culpa, fuga dolores vitae praesentium quo inventore harum."
    },
    {
        id: 4,
        question: "What measures does EcoSolution take to ensure the environmental sustainability of its products?", 
        answer:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure magnam voluptas deleniti culpa, fuga dolores vitae praesentium quo inventore harum."
    },
    {
        id: 5,
        question: "How does EcoSolution engage with local communities and support a just transition to renewable energy?", 
        answer: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure magnam voluptas deleniti culpa, fuga dolores vitae praesentium quo inventore harum."
    }  
];

export default faqData;